module.exports = __webpack_public_path__ + "img/taketomi_12.23db6fde.jpg";